export const resources = {
  SpeechFailedUploadDatasetText: '',
  SpeechFailedUpdateDatasetTitle: '',
  SpeechFailedUpdateDatasetText: '',
  SpeechFailedTrainModelText: '',
  SpeechFailedUpdateModelTitle: '',
  SpeechFailedUpdateModelText: ''
};
